document.addEventListener('DOMContentLoaded', function() {
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

  addToCartForms.forEach(form => {
    form.addEventListener('submit', function() {
      // Don't preventDefault - let Udesly handle the actual cart add
      // Just wait a moment then update our UI
      setTimeout(function() {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            // Update cart count
            document.dispatchEvent(new CustomEvent('cart:change', { detail: cart }));
            if (window.updateCart) window.updateCart();
            if (window.openCartDrawer) window.openCartDrawer();

            // Update any cart count elements on the page
            const cartCountEls = document.querySelectorAll('.cart-count, .cart-item-count, [data-cart-count]');
            cartCountEls.forEach(el => {
              el.textContent = cart.item_count;
            });
          });
      }, 800); // wait for Udesly's add to finish first
    });
  });
});